import React, {FC} from 'react'
import {useField} from "formik";
import {Checkbox, FormControlLabel} from "@material-ui/core";

interface FormikCheckboxProps {
    name: string;
    label: string;
}

export const FormikCheckbox: FC<FormikCheckboxProps> = ({name, label}) => {
    const [, meta, helpers] = useField<boolean>(name);

    return (
        <FormControlLabel
            control={
                <Checkbox
                    checked={meta.value}
                    onChange={(_e, checked) =>
                        helpers.setValue(checked)
                    }
                />
            }
            label={label}
        />
    )
}